import script from "./landlord-consent-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./landlord-consent-page.vue?vue&type=script&setup=true&lang=ts"

import "./landlord-consent-page.vue?vue&type=style&index=0&id=e8db9b14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8db9b14"]])

export default __exports__